import slickSetup from './slick_config'
import tagBinding from './bind'

tagBinding()
slickSetup()
